import initVueApp from "@/core.js";
const component = require("../views/BrandWorldPage.vue").default;
initVueApp(component);
